
import React, { useCallback, useEffect, useState } from 'react';
import AgentInstructions from './AgentInstructions';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AgentInstructionsModal = ({
    open,
    onClose,
    agentId,
    selectedInstructionId,
    setSelectedInstructionId,
    onInstructionChange
}) => {
    const [isCreateFlowActive, setIsCreateFlowActive] = useState(false);
    const [createFlowCloseHandler, setCreateFlowCloseHandler] = useState(null);

    useEffect(() => {
        if (!open) {
            setIsCreateFlowActive(false);
            setCreateFlowCloseHandler(null);
        }
    }, [open]);

    const handleCreateFlowCloseHandlerChange = useCallback((handler) => {
        setCreateFlowCloseHandler(() => handler || null);
    }, []);

    const handleClose = () => {
        if (createFlowCloseHandler) {
            createFlowCloseHandler();
            return;
        }

        setIsCreateFlowActive(false);
        onClose?.();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={isCreateFlowActive ? false : 'lg'}
            fullWidth
            scroll="paper"
            PaperProps={{
                sx: {
                    width: isCreateFlowActive ? '92vw' : 'min(96vw, 1200px)',
                    maxWidth: isCreateFlowActive ? '1720px' : '1200px',
                    minHeight: isCreateFlowActive ? '86vh' : '60vh',
                    maxHeight: '90vh'
                }
            }}
        >
            <DialogTitle sx={{ pr: 5 }}>
                Agent Instructions
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    width: '100%',
                    minWidth: 0,
                    minHeight: isCreateFlowActive ? 'calc(86vh - 120px)' : '50vh',
                    maxHeight: 'calc(90vh - 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }}
            >
                <AgentInstructions
                    agentId={agentId}
                    selectedInstructionId={selectedInstructionId}
                    setSelectedInstructionId={setSelectedInstructionId}
                    onInstructionChange={onInstructionChange}
                    onClose={handleClose}
                    onCreateFlowActiveChange={setIsCreateFlowActive}
                    onCreateFlowCloseHandlerChange={handleCreateFlowCloseHandlerChange}
                />
            </DialogContent>
        </Dialog>
    );
};

export default AgentInstructionsModal;
